import { styled } from '@mui/system'
import { colors } from '../consts'

export const StatsTableCon = styled('div')(({ theme }) => ({
  marginTop: 32,
  display: 'flex',
  justifyContent: 'flex-start',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginBottom: 10,
  width: '100%',
  '& > div': {
    margin: theme.spacing(1, 2),
  },
}))

export const StatCon = styled('div')(({ theme }) => ({
  '& .stat': {
    color: colors.text,
    fontWeight: 'bold',
    fontSize: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 17,
    },
  },
  '& .statText': {
    fontSize: 20,
    [theme.breakpoints.between('sm', 'md')]: {
      fontSize: 17,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
    },
  },
}))
